import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, mergeMap, tap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { ActivitySubscriptionsHttpService } from './activity-subscriptions-http.service';
import { ActivitySubscriptionsActions } from './activity-subscriptions.store';

@Injectable({ providedIn: 'root' })
export class ActivitySubscriptionsEffects {
  public effects = createEffectFactory(ActivitySubscriptionsActions, this.actions$);

  public fetchActivitySubscriptions$ = this.effects(ActivitySubscriptionsActions.fetch, () =>
    this.activitySubscriptionsService.loadActivitySubscriptions(),
  );

  public updateActivitySubscriptions$ = this.effects(
    ActivitySubscriptionsActions.update,
    ({ payload }) =>
      this.activitySubscriptionsService.updateActivitySubscription(payload).pipe(
        tap(() => {
          this.store.dispatch(ActivitySubscriptionsActions.fetch());
        }),
      ),
  );

  public resetToDefaultActivitySubscriptions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActivitySubscriptionsActions.resetToDefaults),
      mergeMap(() =>
        this.activitySubscriptionsService
          .resetToDefaultActivitySubscriptionPerRole()
          .pipe(
            map(data => ActivitySubscriptionsActions.resetToDefaultsSuccess({ payload: data })),
          ),
      ),
    ),
  );

  constructor(
    private activitySubscriptionsService: ActivitySubscriptionsHttpService,
    private actions$: Actions,
    private store: Store,
  ) {}
}
